import React from 'react';
interface PageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  eyebrow?: React.ReactNode;
}
export function PageHeader({
  title,
  subtitle,
  actions,
  eyebrow
}: PageHeaderProps) {
  return <div className="mb-5 flex flex-wrap items-end justify-between gap-4" data-id="element-143" data-mp="148yy7tzc77et">
      <div data-id="element-144" data-mp="zadv9mspa9mo">
        {eyebrow && <div className="mb-1.5" data-id="element-145" data-mp="zaxc106m6rz4">{eyebrow}</div>}
        <h1 className="font-heading text-[22px] font-bold leading-tight text-navy-900" data-id="element-146" data-mp="uc419fippf2n">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground" data-id="element-147" data-mp="pl46aft5l72s">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2" data-id="element-148" data-mp="ljiw528076wa">{actions}</div>}
    </div>;
}